import { type ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

export type ConsoleLabelTone = "default" | "link";

const consoleLabelVariants = cva(
  `
    m-0 mb-2 text-(length:--console-type-console-label) font-semibold
    tracking-[0.4px] uppercase
  `,
  {
    variants: {
      tone: {
        default: "text-(--console-text-label)",
        link: "text-(--console-text-link)",
      },
      isActive: {
        true: "text-white/70",
        false: null,
      },
    },
    defaultVariants: {
      tone: "default",
      isActive: false,
    },
  },
);

export const ConsoleLabel = ({
  className,
  isActive = false,
  tone = "default",
  ref,
  ...props
}: ComponentProps<"p"> &
  VariantProps<typeof consoleLabelVariants> & {
    isActive?: boolean;
    tone?: ConsoleLabelTone;
  }) => (
  <p
    ref={ref}
    className={cn(consoleLabelVariants({ tone, isActive }), className)}
    {...props}
  />
);
